import { EBAY_SSO_STORAGE_TTL_MS } from './constants';

import { getLocalStorageItem, removeLocalStorageItem } from '@/modules/storage';
import { safeJsonParse } from '@/modules/storage/helpers';

export type EbayStateRecord = {
  state: string;
  returnTo: string;
  createdAt: number;
};

export type EbayPendingResult = {
  code: string | null;
  state: string | null;
  createdAt: number;
};

export function readEbayStorageRecord<T extends { createdAt: number }>(
  key: string
): T | null {
  const record = safeJsonParse(getLocalStorageItem(key)) as T | null;

  if (
    typeof record?.createdAt !== 'number' ||
    Date.now() - record.createdAt > EBAY_SSO_STORAGE_TTL_MS
  ) {
    removeLocalStorageItem(key);
    return null;
  }

  return record;
}
